import { createApp } from 'vue'
import i18n from './i18n'
import { createVuestic } from 'vuestic-ui'
import { createGtm } from '@gtm-support/vue-gtm'

import stores from './stores'
import router from './router'
import vuesticGlobalConfig from './services/vuestic-ui/global-config'
import App from './App.vue'

import ApiService from './services/api/api.service'
import { TokenService } from './services/api/storage.service'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import PrimeVue from 'primevue/config'
import Aura from '@primevue/themes/aura'
// use sweetalert2
// use Quill
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import 'viewerjs/dist/viewer.css'

import { quillEditor } from 'vue3-quill'
import VueViewer from 'v-viewer'

const app = createApp(App)

app.use(VueSweetalert2)

//define QuillEditor as global component
app.use(quillEditor)
app.use(VueViewer)

app.use(PrimeVue, {
  theme: {
    preset: Aura,
  },
})

ApiService.init(import.meta.env.VITE_API_URL)
// If token exists set header
if (TokenService.getToken()) {
  ApiService.setHeader()
}

app.use(stores)
app.use(router)
app.use(i18n)
app.use(createVuestic({ config: vuesticGlobalConfig }))

if (import.meta.env.VITE_APP_GTM_ENABLED) {
  app.use(
    createGtm({
      id: import.meta.env.VITE_APP_GTM_KEY,
      debug: false,
      vueRouter: router,
    }),
  )
}

app.mount('#app')
